export default "__VITE_ASSET__Dm2HBC3s__"